import React, { useState } from 'react';
import { X, Edit, DollarSign } from 'lucide-react';
import { usePOCManagement } from '@/hooks/admin/usePOCManagement';

export function EditAmplifyPOCDialog({ poc, isOpen, onClose, onSuccess }) {
  const { editAmplifyPOC } = usePOCManagement();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    poc_name: poc.poc_name || '',
    traditional_budget: poc.traditional_budget || 0,
    address: poc.address || '',
    city: poc.city || '',
    region: poc.region || ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await editAmplifyPOC(poc.id, formData);
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-gray-900 rounded-lg shadow-xl max-w-lg w-full m-4">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-xl font-semibold flex items-center gap-2 text-gray-900 dark:text-white">
            <Edit className="h-5 w-5 text-gray-600 dark:text-gray-400" />
            Edit Amplify POC: {poc.id}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"><X className="h-6 w-6" /></button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {error && <div className="bg-red-50 border border-red-200 rounded p-3 text-sm text-red-800 dark:bg-red-900/20 dark:border-red-800 dark:text-red-200">{error}</div>}

          <div>
            <label className="block text-sm font-medium mb-1 dark:text-gray-300">POC Name</label>
            <input type="text" value={formData.poc_name} onChange={(e) => setFormData({...formData, poc_name: e.target.value})} className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800 dark:border-gray-600 dark:text-white" />
          </div>

          <div>
            <label className="flex items-center gap-1 text-sm font-medium mb-1 dark:text-gray-300">
              <DollarSign className="h-4 w-4" />
              Traditional Budget
            </label>
            <input type="number" step="0.01" value={formData.traditional_budget} onChange={(e) => setFormData({...formData, traditional_budget: parseFloat(e.target.value) || 0})} className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800 dark:border-gray-600 dark:text-white" />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1 dark:text-gray-300">City</label>
              <input type="text" value={formData.city} onChange={(e) => setFormData({...formData, city: e.target.value})} className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800 dark:border-gray-600 dark:text-white" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1 dark:text-gray-300">Region</label>
              <input type="text" value={formData.region} onChange={(e) => setFormData({...formData, region: e.target.value})} className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800 dark:border-gray-600 dark:text-white" />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1 dark:text-gray-300">Address</label>
            <input type="text" value={formData.address} onChange={(e) => setFormData({...formData, address: e.target.value})} className="w-full px-3 py-2 border rounded-lg dark:bg-gray-800 dark:border-gray-600 dark:text-white" />
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t dark:border-gray-700">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800">Cancel</button>
            <button type="submit" disabled={isSubmitting} className="px-4 py-2 text-sm text-white bg-gray-900 dark:bg-gray-700 hover:bg-gray-800 dark:hover:bg-gray-600 rounded-lg disabled:opacity-50">{isSubmitting ? 'Saving...' : 'Save Changes'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditAmplifyPOCDialog;
